import {FiChevronDown, FiChevronUp} from "react-icons/fi";
import React, { useState } from "react";

const ExpandablePanelHeader = (props) => {
  const handleSetExpanded = () => {
    props.setExpanded(false)
  }
  return (
    <div className={`${props.className} xl:px-3 xl:py-2 px-2 py-1 relative font-medium lg:text-xl text-lg`}>
        {props.children}
        <div className="absolute top-1/2 -translate-y-1/2 right-4 cursor-pointer">
          {props.expanded 
          ? <FiChevronDown size={28} onClick={handleSetExpanded}/> 
          : <FiChevronUp size={28} onClick={() => props.setExpanded(true)}/>}
        </div>
    </div>
  )
}

export default ExpandablePanelHeader